import Button from '../../../components/CustomButtons/ButtonTS';
import EditAttributesOutlined from '@material-ui/icons/VerticalAlignBottom';
import React from 'react';
import { INode } from '../../helpers/interfaces';
import Loading from '../Loading/Loading';
import Tooltip from "@material-ui/core/Tooltip";

interface IEditIconProps {
	show: boolean;
	node: INode;
	showBaseCard(node: INode): void;
	isEditing: boolean;
}

export const BaseNodeIcon = (props: IEditIconProps) => {
	const { isEditing, show, showBaseCard, node } = props;
	if (!show) {
		return null;
	}
	return (
        <Tooltip title="Set base">
            <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
                    onClick={() => showBaseCard(node)}
                    data-testid='baseIcon'
                >
                    <EditAttributesOutlined />
                </Button>
            </div>
        </Tooltip>
	);
};

export default BaseNodeIcon;
